import NotesItem from './notesItem';

export default NotesItem;
